import styled from 'styled-components';
import device from '../../../components/mediaQueries';

const CloseImg = styled.img`
  width: 20px;
  height: auto;
`;

const ModalHeaderBody = styled.div`
  color: #999;
  font-family: "Avenir Light", "Arial", sans-serif;
  font-size: 1em;
  padding: 3% 0;
  text-align: justify;
  user-select: none;
  line-height: 1;
`;

const ModalHeaderTitle = styled.div`
  color: #333333;
  font-size: 15px;
  font-family: "Avenir Black", "Arial Black", sans-serif;
  letter-spacing: 1px;
  text-transform: uppercase;
  user-select: none;
  display: flex;
  ${device.mobile`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 4px;
  `}
`;

const ModalHeaderWrapper = styled.div`
  margin: 7% 5% 5% 5%;
  outline: none;
`;

export { CloseImg, ModalHeaderBody, ModalHeaderTitle, ModalHeaderWrapper };
